module.exports = __webpack_public_path__ + "img/hr-carousel-background-medium@2x.e2be25e9.png";